import React, { useState, useEffect } from "react";
import "./css/About.css";

const appsWithUrls = [
  { name: "VyralSocial",    url: "https://officialripple.com" },
  { name: "VyralFans",      url: "https://vyralfans.com" },
  { name: "VyralSwingLife", url: "https://vyralswinglife.com" },
  { name: "VyralMining",    url: "https://vyralmining.com" },
];

const values = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z"/>
      </svg>
    ),
    title: "Innovation",
    body: "Pushing boundaries with every product we build",
    accent: "pink",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
        <circle cx="9" cy="7" r="4"/>
        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
    title: "Community",
    body: "Building spaces where people connect authentically",
    accent: "blue",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
        <polyline points="22 4 12 14.01 9 11.01"/>
      </svg>
    ),
    title: "Quality",
    body: "Excellence in every line of code and pixel",
    accent: "purple",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
        <circle cx="12" cy="12" r="10"/>
        <line x1="2" y1="12" x2="22" y2="12"/>
        <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
      </svg>
    ),
    title: "Global Reach",
    body: "Connecting creators and audiences worldwide",
    accent: "pink",
  },
];

const pillars = [
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <circle cx="12" cy="12" r="10"/>
        <path d="M8 14s1.5 2 4 2 4-2 4-2"/>
        <line x1="9" y1="9" x2="9.01" y2="9"/>
        <line x1="15" y1="9" x2="15.01" y2="9"/>
      </svg>
    ),
    label: "Our Mission",
    body: "To revolutionize how people connect, create, and share by building cutting-edge platforms where communities thrive and creators are rewarded for their vision and voice.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
        <line x1="8" y1="21" x2="16" y2="21"/>
        <line x1="12" y1="17" x2="12" y2="21"/>
      </svg>
    ),
    label: "What We Build",
    body: "Our ecosystem includes VyralSocial, VyralFans, VyralReflect, VyralMining, VyralProductions, VyralMusic, VyralStreams, and more, each serving a unique purpose within the Vyral experience.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M12 2L2 7l10 5 10-5-10-5z"/>
        <path d="M2 17l10 5 10-5"/>
        <path d="M2 12l10 5 10-5"/>
      </svg>
    ),
    label: "Our Divisions",
    body: "From app development and music production to branding, advertising, and news media. Vyral Media Group operates across multiple industries under one unified vision.",
  },
  {
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.4">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
      </svg>
    ),
    label: "Our Philosophy",
    body: "We believe in being \"Official.\" At Vyral Media Group, we foster trust, creativity, and authenticity across every experience we offer. Quality and innovation drive everything we build.",
  },
];

const About = () => {
  const [currentAppIndex, setCurrentAppIndex] = useState(0);
  const [isAnimating, setIsAnimating]         = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsAnimating(true);
      setTimeout(() => {
        setCurrentAppIndex((prev) => (prev + 1) % appsWithUrls.length);
        setIsAnimating(false);
      }, 300);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  const currentApp = appsWithUrls[currentAppIndex];

  return (
    <div className="ab-page">

      {/* ── Hero ── */}
      <section className="ab-hero">
        <div className="ab-hero-inner">
          <p className="ab-eyebrow">Who We Are</p>
          <h1>Vyral Media Group</h1>
          <p className="ab-tagline">
            A powerhouse in media and technology, developing innovative
            applications and services that empower creators, businesses,
            and communities worldwide.
          </p>
        </div>
      </section>

      <div className="ab-body">

        {/* ── Story ── */}
        <section className="ab-story">
          <div className="ab-story-quote">
            <blockquote>Creators deserve better.</blockquote>
          </div>
          <div className="ab-story-text">
            <h2>Our Story</h2>
            <p>
              Vyral Media Group was founded with a simple belief: creators deserve better.
              Better platforms, better tools, and better opportunities to share their voice
              with the world. Today, we're building an ecosystem of apps and services that
              put creators first, and we're just getting started.
            </p>
          </div>
        </section>

        {/* ── Values ── */}
        <section className="ab-values">
          <div className="ab-section-header">
            <h2>What Drives Us</h2>
            <p>Four pillars that shape every decision we make</p>
          </div>
          <div className="ab-values-grid">
            {values.map(({ icon, title, body, accent }) => (
              <div key={title} className={`ab-value-card ab-accent-${accent}`}>
                <div className="ab-value-icon">{icon}</div>
                <h3>{title}</h3>
                <p>{body}</p>
              </div>
            ))}
          </div>
        </section>

        {/* ── Pillars ── */}
        <section className="ab-pillars">
          <div className="ab-section-header">
            <h2>Our Foundation</h2>
            <p>The core of everything we do</p>
          </div>
          <div className="ab-pillars-grid">
            {pillars.map(({ icon, label, body }) => (
              <div key={label} className="ab-pillar-card">
                <div className="ab-pillar-icon">{icon}</div>
                <div className="ab-pillar-content">
                  <h3>{label}</h3>
                  <p>{body}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        {/* ── CTA ── */}
        <section className="ab-cta">
          <div className="ab-cta-inner">
            <h2>Ready to be part of the journey?</h2>
            <p>Join thousands of creators already building with Vyral</p>
            <a
              href={currentApp.url}
              target="_blank"
              rel="noopener noreferrer"
              className={`ab-cta-btn${isAnimating ? " fade-out" : " fade-in"}`}
            >
              Explore {currentApp.name} ↗
            </a>
          </div>
        </section>

      </div>
    </div>
  );
};

export default About;
